import { connect } from 'react-redux';
import VideosComponent from '../components/videosComponent';
import {
    getYoutubePlaylistsIfNeeded, getYoutubeLatestVideoIfNeeded, getYoutubeVideoByTitleIfNeeded,
} from '../actions/videosActions';

const mapStateToProps = (state) => ({
    videos: state.videos.videosPage.videos,
    playlists: state.videos.videosPage.playlists,
    featuredVideo: state.videos.videosPage.featuredVideo,
    notFound: state.videos.videosPage.notFound,
    isMobile: state.clientInfo.isMobile,
});

const mapDispatchToProps = (dispatch) => ({
    // we need to the have a promise so that we can wait for it to return in didMount
    getYoutubePlaylistsIfNeeded: (limit) => dispatch(getYoutubePlaylistsIfNeeded(limit)),
    getYoutubeLatestVideoIfNeeded: (limit) => {
        dispatch(getYoutubeLatestVideoIfNeeded(limit));
    },
    getYoutubeVideoByTitleIfNeeded: (videoTitle) => {
        dispatch(getYoutubeVideoByTitleIfNeeded(videoTitle));
    },
});

const VideosContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(VideosComponent);

export default VideosContainer;
